import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h7-testimonial-slider", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".h5-story-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".h5-story-next",
        prevEl: ".h5-story-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true);
  }, []);

  return (
    <>

      {/*===== HERO AREA STARTS =======*/}
      <div className="hero2-section-area sp1">
        <div className="bg-img">
          <img src="assets/img/all-images/hero/hero-img2.png" className="rounded-[24px]" alt="" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero-header">
                <h5> Your Partner in Lifelong journey
                </h5>
                <div className="space18" />
                <h1 className="text-anime-style-1">
                  Wellness That Covers More Than You Think
                </h1>
                <div className="space20" />
                <p>
                  Your health goes beyond just doctor visits — and so do our plans. With our OPD & Wellness Plans, you get access to a wide range of services designed to support your complete well-being. From general consultations and diagnostics to preventive care, mental wellness, dental support, and more — it’s all included.
                </p>
                <div className="space28" />
                <div className="btn-area1">
                  <Link to="/plans" className="vl-btn2 diff">
                    <span className="text">
                      Discover All Plans
                      <i className="fa-solid fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero2-images">
                <img
                  src="assets/img/elements/elements6.png"
                  alt=""
                  className="elements6"
                />
                <div className="img1">
                  <img src="assets/img/all-images/hero/hero.jpg" alt="" />
                </div>
                <div className="hero-contact aniamtion-key-1">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={28}
                      height={28}
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M15.2956 2.33927C14.6552 2.26812 14.0784 2.7296 14.0072 3.36999C13.9361 4.01038 14.3976 4.58719 15.038 4.65833C17.1424 4.89212 19.1048 5.83452 20.603 7.33079C22.1011 8.82707 23.046 10.7883 23.2824 12.8925C23.3543 13.5327 23.9317 13.9934 24.5721 13.9215C25.2124 13.8496 25.6731 13.2722 25.6011 12.6318C25.3056 10.0017 24.1246 7.55017 22.2518 5.67983C20.3791 3.8095 17.9262 2.63151 15.2956 2.33927Z"
                        fill="#243A5E"
                      />
                      <path
                        d="M15.3903 7.02181C14.7579 6.89843 14.1453 7.31107 14.0218 7.94347C13.8984 8.57589 14.311 9.18857 14.9435 9.31196C15.8551 9.48982 16.6929 9.93567 17.3496 10.5924C18.0065 11.2492 18.4522 12.087 18.6302 12.9987C18.7536 13.631 19.3662 14.0436 19.9987 13.9203C20.631 13.7969 21.0436 13.1843 20.9203 12.5518C20.6535 11.1844 19.9848 9.92767 18.9996 8.94252C18.0144 7.95737 16.7578 7.2886 15.3903 7.02181Z"
                        fill="#243A5E"
                      />
                      <path
                        d="M8.42329 13.792C8.08577 14.2003 7.74835 14.6085 7.41381 15.0186C8.93041 17.4959 11.008 19.4949 13.5576 20.9234C13.8889 20.5958 14.2212 20.2691 14.5533 19.9424C15.2466 19.2604 15.9398 18.5785 16.6257 17.8896C17.003 17.5106 17.3818 17.1301 17.8557 16.9096C18.2687 16.7173 18.7209 16.6246 19.1761 16.6385C19.6987 16.6546 20.1966 16.8551 20.6928 17.0547C20.9969 17.1772 21.3047 17.2947 21.6131 17.4124C22.3121 17.6794 23.014 17.9472 23.6817 18.2758C23.9782 18.4216 24.2802 18.604 24.5448 18.8826C24.9319 19.2901 25.193 19.8006 25.2967 20.353C25.3676 20.7307 25.3387 21.0822 25.2833 21.408C25.1475 22.207 24.9357 22.9981 24.7249 23.7857C24.6358 24.1188 24.5469 24.4512 24.4639 24.7832C24.3341 25.3026 23.8674 25.6671 23.332 25.6671C19.8901 25.6671 16.2962 25 13.2265 23.3885C9.71994 21.6315 6.87616 18.9024 4.98817 15.4892C3.12099 12.247 2.33203 8.37871 2.33203 4.66709C2.33203 4.13176 2.69636 3.66512 3.2157 3.53527L5.54834 2.95203C5.93641 2.85498 6.289 2.76681 6.5908 2.71552C6.91662 2.66015 7.26816 2.63118 7.64577 2.70208C8.19814 2.8058 8.70877 3.0669 9.11627 3.45397C9.39482 3.71857 9.57717 4.02051 9.72305 4.31709C10.0734 5.02932 10.3587 5.77812 10.643 6.52407C10.7693 6.85564 10.8955 7.18663 11.027 7.51361C11.2025 7.94992 11.379 8.3886 11.4107 8.8534C11.4383 9.25897 11.3808 9.66586 11.242 10.0479C11.0829 10.4858 10.7918 10.8585 10.5024 11.2291C9.82583 12.0955 9.1244 12.944 8.42329 13.792Z"
                        fill="#243A5E"
                      />
                    </svg>
                  </span>
                  <div className="text">
                    <p>Customer Care</p>
                    <div className="space14" />
                    <a href="tel:18002681155">18002681155</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*===== HERO AREA ENDS =======*/}



      {/*===== ABOUT AREA STARTS =======*/}
      <div className="about2-section-area sp1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about2-images-area">
                <img
                  src="assets/img/elements/elements7.png"
                  alt=""
                  className="elements7 keyframe5"
                />
                <div className="check-text aniamtion-key-1">
                  <img src="assets/img/icons/check3.svg" alt="" />
                  <p>With 15+ years of experience</p>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime">
                      <img src="assets/img/all-images/about/about-img5.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space50 d-md-block d-none" />
                    <div className="space30 d-md-none d-block" />
                    <div className="img1 image-anime">
                      <img src="assets/img/all-images/about/about-img6.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-heading heading2">
                <h5> About Us </h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">
                  Empowering Your Health With Expertise And Care
                </h2>
                <div className="space16" />
                <p>
                  From general consultations and diagnostics to preventive care, mental wellness, dental support, and more — it’s all included.
                </p>
                <div className="space8" />
                <div className="row">
                  <div className="col-lg-6">
                    <ul className="about-list">
                      <li>
                        <img src="assets/img/icons/check2.svg" alt="" /> <span> Specialist Consultations</span>
                      </li>
                      <li>
                        <img src="assets/img/icons/check2.svg" alt="" /> <span> Lab Tests & Diagnostics</span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul>
                      <li>
                        <img src="assets/img/icons/check2.svg" alt="" /> <span> Mental Wellness</span>
                      </li>
                      <li>
                        <img src="assets/img/icons/check2.svg" alt="" /> <span>Dental, Skin & More</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="space36" />
                <div className="btn-area1">
                  <Link to="/contact" className="vl-btn2">
                    <span className="text">
                      Schedule An Appointment{" "}
                      <i className="fa-solid fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== ABOUT AREA ENDS =======*/}


      {/* PROCESS AREA STARTS */}
      <section className="py-10 bg-[#F3F5F4] sm:py-16 lg:py-24">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">
              How does it work?
            </h2>
            <p className="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
              Getting started with us is quick, easy, and
              completely digital. Here’s how you can take control of your health
              in just a few simple steps:
            </p>
          </div>
          <div className="relative mt-12 lg:mt-20">
            <div className="absolute inset-x-0 hidden xl:px-44 top-2 md:block md:px-20 lg:px-28">
              <img
                className="w-full"
                src="https://cdn.rareblocks.xyz/collection/celebration/images/steps/2/curved-dotted-line.svg"
                alt=""
              />
            </div>
            <div className="relative grid grid-cols-1 text-center gap-y-12 md:grid-cols-3 gap-x-12">
              <div>
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">1</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Choose a Plan
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Select the OPD wellness plan that suits your individual or
                  family needs.
                </p>
              </div>
              <div>
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">2</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Log Into PWA
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Register online in minutes — no paperwork, no waiting.
                </p>
              </div>
              <div >
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">3</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Book Services
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Need a doctor, lab test, or medicine? Booking is just a click
                  away.
                </p>
                {/*  */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* PROCESS AREA ENDS */}

      {/*===== WORKS AREA STARTS =======*/}
      <div className="works7-section-area sp1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading7">
                <h5>Why Choose Us</h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">
                  Got Questions? We’ve Got Your Health Covered!
                </h2>
                <div className="space16" />
                <p>
                  We know healthcare choices can be confusing — that’s why we’re
                  here to help. From OPD benefits to wellness checkups, get
                  clear, simple answers about how our plans work, what’s
                  included, and how they protect your family’s health. Feel
                  confident about every step of your care journey!
                </p>
                <div className="space12" />
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is covered under an OPD plan?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          OPD plans cover doctor consultations, diagnostic
                          tests, and prescribed medicines — with hospitalization
                          coverage (if you bought hospital coverage plan) — for
                          everyday medical needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        What benefits do wellness plans offer?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Wellness plans include annual health checkups,
                          lifestyle and nutrition guidance, mental wellness
                          support, and preventive screenings to keep you
                          healthy.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Can I include my family in these plans?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, Upto 4 family members covers your spouse,
                          children, and parents under one affordable plan.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space32" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="works-images-area">
                <div className="img1 text-end image-anime lg:translate-x-[160px]">
                  <img src="assets/img/all-images/works/work-img15.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== WORKS AREA ENDS =======*/}

      {/*===== SERVICE AREA STARTS =======*/}
      <div
        className="service7-section-area sp8"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/bg8.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="heading7">
                <h5>Services</h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">
                  Exceptional Services for Every Stage of Life
                </h2>
              </div>
            </div>
            <div className="col-lg-2" />
            <div className="col-lg-5">
              <div className="heading7">
                <div className="space20 d-lg-none d-block" />
                <p>
                  We are family dedicated providing exceptional <br /> care for
                  OPD and Welness plans.
                </p>
              </div>
            </div>
          </div>
          <div className="space60" />
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img src="assets/img/icons/doctor-consult.svg" width="28" alt="" />
                  </div>
                  <div className="space24" />
                  <div className="title">Specialist Consultations</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      Connect with top specialists across fields like dermatology, cardiology, and more. Get personalized, expert care without the hassle of referrals or long waiting times.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea box2">
                <div className="service-boxarea">
                  <div className="icons">
                    <img
                      src="assets/img/icons/tele-consult.svg"
                      width="28"
                      alt=""
                    />
                  </div>
                  <div className="space24" />
                  <div className="title">Tele Doctor Consultation</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      Get expert medical advice from licensed doctors over a phone call—anytime, anywhere. No travel, no waiting rooms, just instant care at your convenience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img
                      src="assets/img/icons/medicines.svg"
                      width="28"
                      alt=""
                    />
                  </div>
                  <div className="space24" />
                  <div className="title">Prescribed Pharmacy</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      Receive doctor-approved medicines delivered to your doorstep. Safe, timely, and hassle-free access to the prescriptions you need—when you need them.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="service-hidden-boxarea">
                <div className="service-boxarea">
                  <div className="icons">
                    <img src="assets/img/icons/dental.svg" width="28" alt="" />
                  </div>
                  <div className="space24" />
                  <div className="title">At Home Dental Scans</div>
                  <div className="space16" />
                  <div className="text">
                    <div className="space20" />
                    <p>
                      Book professional dental scans from the comfort of your home. Certified technicians, with modern equipment, and accurate reports — without stepping out.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== SERVICE AREA ENDS =======*/}


    </>
  );
};

export default HomePage;
